import * as React from 'react';
import {
  Create,
  SimpleForm,
} from 'react-admin';
import ConsumablesCalculatorMultiControlForm from './ConsumablesCalculatorMultiControlForm';
import FormToolbar from '../shared/FormToolbar';

const ConsumablesCalculatorMultiControlEdit = props => (
  <Create {...props}>
    <SimpleForm
      toolbar={<FormToolbar />}
      redirect="list"
    >
      <ConsumablesCalculatorMultiControlForm {...props} />
    </SimpleForm>
  </Create>
);

export default ConsumablesCalculatorMultiControlEdit;
